import React from 'react';
import { Layout } from '../components';
import { TypePasswordForm } from './components';

export const PasswordStep = () => (
  <Layout>
    <TypePasswordForm data-testid="SignIn.TypePasswordForm" />
  </Layout>
);
